module.exports = __webpack_public_path__ + "Flag-654.04bc72ecdbd21b8082b19b55fa532a62.svg";